import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforePlayerContractExtendedEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public years: number,
    public wage: number,
  ) {
    super();
  }
}